module.exports = __webpack_public_path__ + "static/img/crm_body_right_1.62f31d9e.png";